import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) { config.headers = config.headers || {}; config.headers.Authorization = `Bearer ${token}`; }
  return config;
});

export async function listProcurement(params = {}) {
  const { data } = await client.get('/procurement', { params });
  return data; // { items, totals }
}
export async function updateProcurement(id, estado) {
  const { data } = await client.patch('/procurement', { id, estado });
  return data.item;
}
export async function makeProcurementContent(id, tipo) {
  const { data } = await client.post(`/procurement/${id}/make-content`, { tipo });
  return data;
}
